import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M20.0825 14.64C19.5659 15.156 19.3376 15.912 19.4578 16.644L20.2266 21.348C20.4669 22.812 19.3497 24 18.0882 24C17.7519 24 17.4035 23.916 17.0791 23.736L13.0185 21.516C12.7061 21.348 12.3577 21.252 12.0093 21.252C11.661 21.252 11.3126 21.336 11.0002 21.516L6.93961 23.736C6.60323 23.916 6.26685 24 5.93047 24C4.66904 24 3.55178 22.812 3.79205 21.348L4.56092 16.644C4.68106 15.912 4.4528 15.156 3.93621 14.64L0.656503 11.316C-0.628952 10.008 0.0798504 7.72801 1.85786 7.45201L6.38699 6.768C7.09579 6.66 7.70848 6.192 8.02084 5.532L10.0511 1.26C10.4476 0.420004 11.2285 0 11.9973 0C12.7782 0 13.5471 0.420004 13.9435 1.26L15.9738 5.532C16.2862 6.204 16.8989 6.66 17.6077 6.768L22.1368 7.45201C23.9148 7.71601 24.6356 10.008 23.3382 11.316L20.0825 14.64Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
